(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-upsell"] && !Shopify.designMode) return;
  try {
    const observer = new MutationObserver((mutations) => {
    for (const el of document.querySelectorAll('.product-upsell .swym-atw-button-container')) {
      el.remove();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
